<div class="point-transaction-modal-root" *transloco="let t">
  <div class="title">
    <app-label isGray class="label">{{ 'create-point-transaction' | transloco }} ({{data.family.value}})</app-label>
    <button id="close-filter-date-icon" (click)="onCloseClick()" mat-icon-button class="close-button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <div class="selector-area">
      <div class="chip" id="add-point-transaction" (click)="addPoints()" ngClass="{{addOrRemovePoints.addPoints ? 'selected' : ''}}">
        <mat-icon>add_circle</mat-icon>
        <div>{{ 'add-points' | transloco }}</div>
    </div>
    <div class="chip" id="remove-point-transaction" (click)="removePoints()" ngClass="{{addOrRemovePoints.removePoints ? 'selected' : ''}}">
        <mat-icon>do_not_disturb_on</mat-icon>
        <div>{{ 'remove-points' | transloco }}</div>
    </div>
    </div>
    <div class="points-area">
      <div class="labeled-score-star">
        <div class="label">
          {{ 'current-points' | transloco }}
        </div>
        <div class="score-area">
          <span class="score">{{ data.totalPoints | number:'': language }}</span>
          <mat-icon class="icon">stars</mat-icon>
        </div>
      </div>
      <div class="labeled-score-star after-transition"
          [ngClass]="[addOrRemovePoints.removePoints ? 'red-points' : 'green-points']">
        <div class="label" *ngIf="showNumber(calculateAfterTransaction())">
          {{ 'after-transaction' | transloco }}
        </div>
        <div class="score-area" *ngIf="showNumber(calculateAfterTransaction())">
          <span class="score">{{ calculateAfterTransaction() | number:'': language }} </span>
          <mat-icon class="icon">stars</mat-icon>
        </div>
      </div>
    </div>
    <div class="transaction-container">
      <div class="transaction-value-container">
        <app-input id="transaction-value-input"
            [label]="t('transaction-value')"
            [control]="form.controls.transactionValue"
            [customErrorMessage]="exceededLimitKeys.length ? t('limits.valueExceedsLimits', { limits: exceededLimitsLabelString }) : null">
        </app-input>
        <div class="points-avaiable-modal" *ngIf="data.pointBalance">
          <div>{{t('available-business')}} <span><strong>{{data.pointBalance.businessBalance | number:'': language}}</strong></span></div>
          <div>{{t('points-left')}}</div>
          <div class="points-left">
            {{t('month')}}: <span><strong>{{data.pointBalance.totalBalancePerMonth | number:'': language}}</strong></span>
            {{t('year')}}: <span><strong>{{data.pointBalance.totalBalancePerYear | number:'': language}}</strong></span>
          </div>
        </div>
      </div>
      <app-input id="transaction-note-input"
          [label]="t('note')"
          [control]="form.controls.transactionNote"
          [textarea]="true"
          [textareaMaxLength]="300">
      </app-input>
    </div>
    <app-checkbox id="added-points-checkbox"
        [formGroup]="form"
        abstractFormControlName="confirm">
        {{t('confirm-point-transaction')}}
    </app-checkbox>
    <div class="button-area">
      <app-primary-button class="success-button"
            id="success-dialog-btn"
            [disabled]="disableForm()"
            mat-button
            (clickAction)="onSuccessClick()">
        {{ 'create-transaction' | transloco }}
      </app-primary-button>
      <app-primary-button id="fail-dialog-btn"
            mat-button
            (click)="onFailClick()">
        {{ 'cancel' | transloco }}
      </app-primary-button>
    </div>
  </div>
</div>
